import { useState } from "react"
import { createPortal } from "react-dom"
import classNames from "classnames"

import { useAppSelector } from "store/hooks"
import SubscriptionPlan from "types/enums/SubscriptionPlan"
import { ReactComponent as IconAccountSettings } from "assets/svg/modal-icon-account-settings.svg"

import { AccountSettingsThemes } from "modals/AccountSettingsThemes"
import { ModalLayout } from "layouts/ModalLayout"
import { ModalHeader } from "components/common/ModalHeader"

import { AccountSettingsAdditionalInfo } from "../AccountSettingsAdditionalInfo"
import { AccountSettingsIntegration } from "../AccountSettingsIntegration"
import { AccountSettingsPassword } from "../AccountSettingsPassword"
import { AccountSettingsProfile } from "../AccountSettingsProfile"
import AccountSettingsBilling from "./AccountSettingsBilling"

import styles from "./index.module.scss"

interface Props {
  onCancel: () => void
}

export const AccountSettingsModal = ({ onCancel }: Props) => {
  const [currentTab, setCurrentTab] = useState("profile")
  const userProfile = useAppSelector(state => state.user.userProfile)
  const current_subscription = userProfile?.contractor?.subscription_plan
  const hasEPlusPlan = current_subscription === SubscriptionPlan.E_PLUS

  const renderCurrentView = () => {
    switch (currentTab) {
      case "additional-info":
        return <AccountSettingsAdditionalInfo onCancel={onCancel} />
      case "password":
        return <AccountSettingsPassword onCancel={onCancel} />
      case "integration":
        return <AccountSettingsIntegration />
      case "billing":
        return <AccountSettingsBilling />
      case "themes":
        return <AccountSettingsThemes />
      default:
        return <AccountSettingsProfile onCancel={onCancel} />
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="680px" isWithoutFooter={true} onCancel={onCancel}>
          <ModalHeader title="Account Settings">
            <IconAccountSettings />
          </ModalHeader>
          <div>
            <div className={styles.modalTabsWrapper}>
              <nav className={styles.modalTabs}>
                <span
                  onClick={() => setCurrentTab("profile")}
                  className={classNames(styles.modalTab, { [styles.active]: currentTab === "profile" })}
                >
                  Profile
                </span>
                <span
                  onClick={() => setCurrentTab("additional-info")}
                  className={classNames(styles.modalTab, { [styles.active]: currentTab === "additional-info" })}
                >
                  Additional information
                </span>
                <span
                  onClick={() => setCurrentTab("billing")}
                  className={classNames(styles.modalTab, { [styles.active]: currentTab === "billing" })}
                >
                  Billing
                </span>
                <span
                  onClick={() => setCurrentTab("password")}
                  className={classNames(styles.modalTab, { [styles.active]: currentTab === "password" })}
                >
                  Password
                </span>
                <span
                  onClick={() => setCurrentTab("integration")}
                  className={classNames(styles.modalTab, { [styles.active]: currentTab === "integration" })}
                >
                  Integration
                </span>
                {hasEPlusPlan && (
                  <span
                    onClick={() => setCurrentTab("themes")}
                    className={classNames(styles.modalTab, { [styles.active]: currentTab === "themes" })}
                  >
                    Themes
                  </span>
                )}
              </nav>
            </div>
            {renderCurrentView()}
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
